import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectRegularInfrastructure } from '../../../selectors/infrastructure';
import { getIsTransportAccessibilityServiceAvailable } from '../../../selectors/mapServices';
import { sharedInfrastructureEnabledSelector } from '../../../selectors/sharedInfrastructure';
import { EMapService } from '../../../types/map';
import { hasFutureObjects } from '../../../utils/map';

export const useOnboardingMapServices = () => {
  const [services, setServices] = useState<Array<EMapService>>([]);

  const listener = useCallback((event: CustomEvent<EMapService[]>) => {
    // TODO: Убрать игнор и переписать имеющиеся тесты в CD-196681.
    /* istanbul ignore next */
    if (Array.isArray(event.detail)) {
      setServices(event.detail);
    }
  }, []);

  // TODO: Убрать игнор и переписать имеющиеся тесты в CD-196681.
  /* istanbul ignore next */
  useEffect(() => {
    document.addEventListener('map-services:available:v1', listener);

    return () => document.removeEventListener('map-services:available:v1', listener);
  }, []);

  const isSharedInfrastructureEnabled = useSelector(sharedInfrastructureEnabledSelector);

  // TODO: Удалить эти 3 строчки в CD-196681.
  const regularInfrastructure = useSelector(selectRegularInfrastructure);
  const hasFutureService = useMemo(() => hasFutureObjects(regularInfrastructure), [regularInfrastructure]);
  const hasTransportAccessibilityService = useSelector(getIsTransportAccessibilityServiceAvailable);

  // TODO: Убрать игнор и переписать имеющиеся тесты в CD-196681.
  /* istanbul ignore next */
  if (isSharedInfrastructureEnabled) {
    return {
      hasFutureService: services.includes(EMapService.FutureInfrastructure),
      hasTransportAccessibilityService: services.includes(EMapService.TransportAccessibility),
    };
  }

  return {
    hasFutureService,
    hasTransportAccessibilityService,
  };
};
